//React
import * as React from 'react';

//MUI Components
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

//Widgets
import PortalEngine from '../engines/PortalEngine';

function fGetScreenType() {
    let iScreenWidth = window.innerWidth;
    if (iScreenWidth <= 1000) return "mobile";
    else if (iScreenWidth <= 1720) return "desktop";
    else return "widescreen";
}

// Function to display system header with image or text
function fHeaderTitle(sScreenType, sSystemData) {
    if (!sSystemData || (!sSystemData.sSystemName && !sSystemData.sSystemImage)) {
        return null; // Handle missing data gracefully
    }

    let { sSystemName, sSystemImage } = sSystemData;

    // If an image exists, render only the image
    if (sSystemImage) {
        return (
            <img 
                src={sSystemImage} 
                alt={sSystemName || "System Image"} 
            />
        );
    }

    // Otherwise, render the name inside <h5> or <h3>
    if (sScreenType === "mobile") {
        return <h5 style={{ margin: "5px" }}>{sSystemName}</h5>;
    } else {
        return <h3>{sSystemName}</h3>;
    }
}

// Function to display footer system title with image or text
function fFooterTitle(sSystemData) {
    if (!sSystemData || (!sSystemData.sSystemName && !sSystemData.sSystemImage)) {
        return null; // Handle missing data gracefully
    }

    let { sSystemName, sSystemImage } = sSystemData;

    // If an image exists, render only the image
    if (sSystemImage) {
        return (
            <img 
                src={sSystemImage} 
                alt={sSystemName || "Footer Image"}
            />
        );
    }

    // Otherwise, render the system name as text
    return <p id="footer_text">{sSystemName}</p>;
}

function Homepage({ sSystemName }) {
    // Ensure hooks are always called at the top level
    const [currentTab, setCurrentTab] = React.useState("1");
    const [showFooter, setShowFooter] = React.useState(false);
    let systemConfig = null;

    try {
        systemConfig = require(`../config/${sSystemName}.json`);
    } catch (error) {
        console.error("Error loading system config:", error);
    }

    // Use effect for scroll event
    const [debugInfo, setDebugInfo] = React.useState("");

    React.useEffect(() => {
        const contentDiv = document.getElementById("div_content");
    
        if (!contentDiv) return;
    
        const updateFooterVisibility = () => {
            setTimeout(() => { // Ensure DOM updates first
                const scrollHeight = contentDiv.scrollHeight;
                const clientHeight = contentDiv.clientHeight;
                const scrollTop = contentDiv.scrollTop;
    
                const isScrollable = scrollHeight > clientHeight;
                const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
    
                setShowFooter(!isScrollable || isAtBottom);
    
                setDebugInfo(`
                    Scroll Height: ${scrollHeight}
                    Client Height: ${clientHeight}
                    Scroll Top: ${scrollTop}
                    isScrollable: ${isScrollable}
                    isAtBottom: ${isAtBottom}
                    showFooter: ${!isScrollable || isAtBottom}
                `);
            }, 0);
        };
    
        // Run immediately when tab changes
        updateFooterVisibility();
    
        // Listen for scroll events
        contentDiv.addEventListener("scroll", updateFooterVisibility);
    
        return () => {
            contentDiv.removeEventListener("scroll", updateFooterVisibility);
        };
    }, [currentTab]); // Runs when `currentTab` changes 


    // Prevent rendering if config is missing
    if (!systemConfig) {
        return <div>Error loading system configuration.</div>;
    }

    let sScreenType = fGetScreenType();

    return (
        <div id="div_page">
            <pre style={{
            position: "fixed",
            bottom: "50px",
            left: "10px",
            background: "rgba(0,0,0,0.7)",
            color: "white",
            padding: "10px",
            borderRadius: "5px",
            fontSize: "12px"
        }}>
            {debugInfo}
        </pre>

            {/* Tabs and Content inside TabContext */}
            <TabContext value={currentTab}>
            <div id="div_menu">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    {fHeaderTitle(sScreenType, systemConfig.Globals)}
                                </td>
                                <td>
                    <TabList
                        id="tabs"
                        variant="scrollable"
                        onChange={(event, newValue) => setCurrentTab(newValue)}
                        allowScrollButtonsMobile
                    >
                        {systemConfig.Portals.map(
                            (cPortal) =>
                                cPortal.bIsEnabled &&
                                (cPortal.sScreenType === sScreenType || cPortal.sScreenType === "all") && (
                                    <Tab key={cPortal.sTabIndex} label={cPortal.sTabName} value={cPortal.sTabIndex} />
                                )
                        )}
                    </TabList>
                    </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Content Area */}
                <div id="div_content">
                    {systemConfig.Portals.map(
                        (cPortal) =>
                            cPortal.bIsEnabled &&
                            (cPortal.sScreenType === sScreenType || cPortal.sScreenType === "all") && (
                                <TabPanel key={cPortal.sTabIndex} value={cPortal.sTabIndex}>
                                    <PortalEngine
                                        sSystemName={sSystemName}
                                        cPortal={cPortal}
                                        pSetCurrentTab={setCurrentTab}
                                    />
                                </TabPanel>
                            )
                    )}
                </div>
            </TabContext>

            {/* Sticky Footer - Visible When Scrolled to Bottom */}
            <div id="div_footer" className={showFooter ? "visible" : "hidden"}>
                <table>
                    <tbody>
                        <tr>
                            <td>{fFooterTitle(systemConfig.Globals)}</td>
                            <td>
                                <img id="img_passur" src="/PASSUR.png" height="32px" alt="Passur Logo" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Homepage;
